import { render, staticRenderFns } from "./CSRSection.vue?vue&type=template&id=7573ca08&"
import script from "./CSRSection.vue?vue&type=script&lang=js&"
export * from "./CSRSection.vue?vue&type=script&lang=js&"
import style0 from "./CSRSection.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports